import { useCfIdentity, useLogout } from "@civala/shared-ui"
import {
  ActionIcon,
  Avatar,
  Group,
  Menu,
  Text,
  Tooltip,
  UnstyledButton,
  useComputedColorScheme,
  useMantineColorScheme,
} from "@mantine/core"
import { IconExternalLink, IconFlask, IconLogout, IconMoon, IconSun } from "@tabler/icons-react"

import { useDemoMode } from "@/hooks/useDemoMode"

/** Right-side topbar content for the portal: demo toggle + theme toggle + account menu. */
export function PortalTopBarRight() {
  const { setColorScheme } = useMantineColorScheme()
  const computedColorScheme = useComputedColorScheme("light")
  const isDark = computedColorScheme === "dark"
  const identity = useCfIdentity()
  const logout = useLogout()
  // Device-local demo mode: on reveals the out-of-date screens, each tagged "Demo".
  const [demoMode, setDemoMode] = useDemoMode()

  return (
    <>
      <Tooltip
        label={demoMode ? "Demo mode: showing out-of-date screens" : "Demo mode: current screens only"}
        multiline
        w={220}
      >
        <ActionIcon
          variant={demoMode ? "light" : "subtle"}
          color={demoMode ? "pitchNegative" : "gray"}
          size="md"
          onClick={() => setDemoMode((v) => !v)}
          aria-label="Toggle demo mode"
        >
          <IconFlask size={18} stroke={1.5} />
        </ActionIcon>
      </Tooltip>
      <Tooltip label={isDark ? "Light mode" : "Dark mode"}>
        <ActionIcon variant="subtle" color="gray" size="md" onClick={() => setColorScheme(isDark ? "light" : "dark")}>
          {isDark ? <IconSun size={18} stroke={1.5} /> : <IconMoon size={18} stroke={1.5} />}
        </ActionIcon>
      </Tooltip>
      <Menu position="bottom-end" width={220} withArrow>
        <Menu.Target>
          <UnstyledButton aria-label="Account menu">
            <Group gap="xs" style={{ cursor: "pointer" }} wrap="nowrap">
              <Avatar size="sm" radius="xl" color="pitchNavy">
                {identity.initials}
              </Avatar>
              <Text size="xs">{identity.givenName || identity.name}</Text>
            </Group>
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Label>Resources</Menu.Label>
          <Menu.Item
            component="a"
            href="https://claude.ai/download"
            target="_blank"
            rel="noreferrer"
            leftSection={<IconExternalLink size={16} stroke={1.5} />}
          >
            Claude Desktop Guide
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item leftSection={<IconLogout size={16} stroke={1.5} />} onClick={logout}>
            Sign out
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </>
  )
}
